import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import App from './App';
import VideoViewer from './pages/VideoViewer';
import './index.css'; // Tailwind CSS
import '@styles/index.css'; // Existing custom styles


ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Navigate to="/lip-balm" replace />} />
                <Route path="/:productSlug" element={<App />} />
                <Route path="/viewer" element={<VideoViewer />} />
            </Routes>
        </BrowserRouter>
    </React.StrictMode>,
);
